import { BASE_PATH_API } from '@root/manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';
import { TotalPercentageDistributionRequestDTO } from '@root/manager-base/data/dtos/total-percentage-distribution/total-percentage-distribution-request.dto';
import { TotalPercentageDistributionResponseDTO } from '@root/manager-base/data/dtos/total-percentage-distribution/total-percentage-distribution-response.dto';
import { IPromise } from 'angular';

const controllerPath = `${BASE_PATH_API}/totalPercentageDistribution`;

const actions = {
    distribute: {
        method: 'POST',
        url: `${controllerPath}/distributionRequest`
    }
};

export interface ITotalPercentageDistributionApi {
    distribute(requestDTO: TotalPercentageDistributionRequestDTO): IPromise<TotalPercentageDistributionResponseDTO[]>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function TotalPercentageDistributionApi(): ITotalPercentageDistributionApi {
    return createActions(actions);
}
